import { useEffect } from 'react';

const useMouseTracker = () => {
    useEffect(() => {
        const backgroundColor = '#344a9d';
        const attachedElements = new Set();

        const handleMouseMove = (e) => {
            const container = e.currentTarget;
            const rect = container.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            container.style.background = `radial-gradient(circle 300px at ${x}px ${y}px, ${backgroundColor}, transparent)`;
        };

        const handleMouseLeave = (e) => {
            const container = e.currentTarget;
            container.style.background = 'transparent';
        };

        const attachListeners = () => {
            const containers = document.querySelectorAll('.opal-card');
            
            containers.forEach((container) => {
                // Only attach if we haven't already
                if (!attachedElements.has(container)) {
                    container.addEventListener('mousemove', handleMouseMove);
                    container.addEventListener('mouseleave', handleMouseLeave);
                    attachedElements.add(container);
                }
            });
        };

        // Initial attachment
        attachListeners();

        // Watch for DOM changes (new cards added)
        const observer = new MutationObserver(() => {
            attachListeners();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: false,
            characterData: false,
        });

        // Cleanup function
        return () => {
            observer.disconnect();
            const containers = document.querySelectorAll('.opal-card');
            containers.forEach((container) => {
                container.removeEventListener('mousemove', handleMouseMove);
                container.removeEventListener('mouseleave', handleMouseLeave);
            });
            attachedElements.clear();
        };
    }, []);
};

export default useMouseTracker;
